import React from "react";
import "./HeaderHamburger.scss";

const HeaderHamburger = () => {
    const toggleMenu = () => {
        const menu = document.querySelector("#main-nav");
        const headerHamburger = document.querySelector(".hamburger-menu-icon");
        if (menu) {
            menu.classList.toggle("active"); // Dodaj lub usuń klasę active
        }
        if (headerHamburger) {
            headerHamburger.classList.toggle("active"); // Dodaj lub usuń klasę active
        }
    };

    return (
        <div className="mobile-menu-open hamburger-menu" onClick={toggleMenu}>
            <span className="hamburger-menu-icon"></span>
        </div>
    );
};

export default HeaderHamburger;
